<template>
  <!-- ON LARGE AND MEDIUM SCREENS ONLY -->
  <div id="banner_content">
    <v-container secondary class="loitering d-flex justify-center pa-0">
      <img src="../images/badgesex150_40_3_white.png" />
    </v-container>
    <template>
      <div class="text-center my-4 white--text">
        <v-btn class="white--text" color="copblue" @click="dialog_faq = true"
          >FAQ - Please Read</v-btn
        >

        <v-dialog v-model="dialog_faq" width="500" id="faq-top">
          <v-card elevation="3">
            <v-card-title>No Loitering Program </v-card-title>
            <v-card-text>
              The <i>No Loitering Program</i> in partnership with the Reno
              Police Department provides an avenue for businesses to establish a
              collaborative approach to address unlawful activity on private
              property, including, but not limited to, side shows, street
              racing, fights, narcotic sales, and other crimes. Through Reno
              Municipal Code titled “Offenses Against Property” Title 8, Chapter
              8.10, businesses have the opportunity to sign up for this program,
              which authorizes the Reno Police Department to trespass
              individuals at participating locations without a property owner
              onsite. <br /><br />
              <p class="vcard-sub-title" style="text-align: center">
                How To Sign Up
              </p>
              <p class="vcard-sub-title">
                Program details can be found on<a
                  href="https://loiter.renopd.com/"
                ></a>
                loiter.renopd.com and includes the following requirements:
              </p>
              <ul>
                <li>
                  A program Letter of Authority on file with the Reno Police
                  Department. Thiscan be completed online or in person at the
                  Public Safety Center.
                </li>
                <li>
                  Purchase of a No Loitering sign from the Public Safety Center.
                  Signs are $40 each. Unofficial signs will not be permitted.
                </li>
              </ul>
              <br />
              <p class="vcard-sub-title" style="text-align: center">
                Signage Best Practices:
              </p>

              <ul>
                <li>
                  If the property does not contain any lineal dimension
                  exceeding three hundred feet, by posting signs at each corner
                  of the area and at intervals not exceeding 100 feet and, if
                  such property has a definite entrance or entrances, at each
                  entrance.
                </li>

                <li>
                  Signs shall not be a visibility hazard to traffic on adjacent
                  streets or parking areas.
                </li>
                <li>
                  Signs shall not reduce parking availability as required by
                  Reno Municipal Code Title 18.
                </li>
                <li>
                  Signs shall not interfere with on-site vehicular circulation.
                </li>
                <li>Signs shall not be posted on windows.</li>
                <li>A sign permit is not required for this program.</li>
                <li>Signs must be hung between 5-7 feet from the ground.</li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog_faq = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <v-container secondary class="loitering d-flex justify-center mt-1 pa-0">
      <h5 class="text--white">Letter of Authority - Loitering</h5>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
/* 0 media q */
@media (min-width: 0px) {
  .vcard-sub-title {
    font-weight: 600;
  }
  #banner_content {
    color: white;
    height: 80px;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #banner_content {
    height: 190px;
  }

  .loitering h5 {
    font-weight: 600;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  #banner_content {
    height: 80px;
  }
}
/* 1440 media q */
@media (min-width: 1440px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "banner",
  mixins: [bus_common],
  data() {
    return {
      dialog_faq: false,
      drawer: false,
      group: null,
    };
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    message2() {
      alert("This button will take the user to the appropriate page.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
    // track page visits/
    console.log("banner mounted");
    // Build the payload
    const payload = {
      url: window.location.href,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };

    console.log("track: " + payload.url);

    // Post to your analytics endpoint
    fetch("/Analytics/Track", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }).catch((err) => {
      console.error("Analytics tracking failed:", err);
    });
  },
};
</script>
